import { defineComponent as _defineComponent } from 'vue'
import { ref } from "vue";
  import Modal from "@/components/ui/Modal.vue";
  import SliderLimited from "@/components/ui/SliderLimited.vue";
  import store from "@/store";
  import { LotRangeInterface } from "@/types/LotRangeInterface";
  import { defaultRange } from "@/static/waitlist";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'AddToWeitlistModal',
  props: {
    isOpen: {
      type: Boolean,
      required: false,
    },
    lotsArray: {
      type: Array,
      default: () => [],
      required: true,
    },
    payload: {
      type: Object,
    },
  },
  emits: ["confirm", "close"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

  const emits = __emit;
  const props = __props;

  const range: LotRangeInterface = defaultRange;
  const lotSize = ref([range.size.min, range.size.max]);
  const budget = ref([range.budget.min, range.budget.max]);
  const frontage = ref([range.frontage.min, range.frontage.max]);

  function onClose() {
    clearForm();
    emits("close");
  }

  const submitForm = () => {
    let waitlistItem = {
      budget: {
        from: budget.value[0],
        to: budget.value[1],
      },
      lotSize: {
        from: lotSize.value[0],
        to: lotSize.value[1],
      },
      frontage: {
        from: frontage.value[0],
        to: frontage.value[1],
      },
    };

    store
      .dispatch("subscription/addToWaitlist", {
        ...waitlistItem,
        ...props.payload,
      })
      .then(() => {
        emits("confirm");
      });
  };

  const clearForm = () => {
    lotSize.value = [range.size.min, range.size.max];
    budget.value = [range.budget.min, range.budget.max];
    frontage.value = [range.frontage.min, range.frontage.max];
  };

const __returned__ = { emits, props, range, lotSize, budget, frontage, onClose, submitForm, clearForm, ref, Modal, SliderLimited, get store() { return store }, get LotRangeInterface() { return LotRangeInterface }, get defaultRange() { return defaultRange } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})